// Flag-gated, read-only, sanitized frontend diagnostics for the serving/nutrition pipeline.
//
// Enabled ONLY when REACT_APP_LOG_FS_SERVINGS === 'true' OR the browser has
// localStorage['fitxess_debug_servings'] === 'true'. Off by default. Emits a SANITIZED structured
// object to the console and never alters any serving math. Strips tokens, headers, cookies, base64
// images and full error/request objects before logging. Safe when window/localStorage are absent.

var _SENSITIVE_KEY = /(authorization|token|cookie|secret|password|session|headers?|config|bearer|api[_-]?key|image_base64|base64|access|refresh)/i;
var _MAX_STR = 2000;
var _MAX_DEPTH = 6;
var _MAX_ARRAY = 50;

// One centralized gating function used by every log call.
export function servingDebugEnabled() {
  try {
    if (typeof process !== 'undefined' && process.env && process.env.REACT_APP_LOG_FS_SERVINGS === 'true') {
      return true;
    }
    if (typeof window !== 'undefined' && window.localStorage) {
      return window.localStorage.getItem('fitxess_debug_servings') === 'true';
    }
  } catch (_e) { /* localStorage may throw (privacy mode / non-browser) -> treat as off */ }
  return false;
}

// Deep-sanitize: drop sensitive keys, truncate long strings (guards base64), bound depth/arrays.
export function sanitizeForDebug(value, _depth) {
  var depth = _depth || 0;
  if (value == null) return value;
  if (typeof value === 'string') return value.length > _MAX_STR ? value.slice(0, _MAX_STR) + '…[truncated]' : value;
  if (typeof value === 'number' || typeof value === 'boolean') return value;
  if (depth >= _MAX_DEPTH) return '[max-depth]';
  if (Array.isArray(value)) {
    return value.slice(0, _MAX_ARRAY).map(function (v) { return sanitizeForDebug(v, depth + 1); });
  }
  if (typeof value === 'object') {
    // Never serialize framework/request objects (Axios config, Errors, DOM/HTTP objects).
    if (value.isAxiosError || value instanceof Error || value.config || value.request || value.response) {
      return '[omitted:non-serializable]';
    }
    var out = {};
    for (var k in value) {
      if (!Object.prototype.hasOwnProperty.call(value, k)) continue;
      if (_SENSITIVE_KEY.test(k)) { out[k] = '[redacted]'; continue; }
      out[k] = sanitizeForDebug(value[k], depth + 1);
    }
    return out;
  }
  return '[unserializable]';
}

export function logServingDebug(stage, payload) {
  if (!servingDebugEnabled()) return;
  try {
    // eslint-disable-next-line no-console
    console.log('[FS_SERVINGS_DEBUG] ' + stage, sanitizeForDebug(payload));
  } catch (_e) { /* noop */ }
}
